import { Popover, Transition } from '@headlessui/react';
import { useGetAdminNotifications } from 'modules/admin/notifications/hooks';
import { useLocation } from 'react-router-dom';
import { BellIcon } from 'ui/components/icon';
import { BadgeBell } from 'ui/components/img/Badge';
import NotificationList from 'ui/partials/Notification/NotificationList';
import { useGetNotifications } from 'ui/partials/hooks';
import { cn, useAdmin } from 'utils/helpers';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';

const Notification = () => {
  const {
    state: { isPreview },
  } = useAppWrapperContext();
  const { isAdmin } = useAdmin();
  const { data: notifications } = (
    isAdmin && !isPreview ? useGetAdminNotifications : useGetNotifications
  )({ status: 'UNREAD' });
  const { pathname } = useLocation();

  return (
    <Popover className={cn('relative', 'flex', 'flex-col', 'items-center')}>
      {({ open }) => (
        <>
          <Popover.Overlay className="fixed inset-0 bg-secondary-lighter opacity-30 z-[99] " />
          <Popover.Button
            role="button"
            className="inline-flex items-center focus:outline-none"
            disabled={pathname === '/notifications'}
          >
            <BadgeBell
              count={notifications?.length ?? 0}
              icon={
                <BellIcon
                  className={cn(
                    'h-[20px] w-[20px]',
                    'text-secondary-dark hover:text-primary-base disabled:pointer-events-none',
                    'transition',
                  )}
                />
              }
            />
          </Popover.Button>
          <Transition
            className={cn('fixed top-0 right-0 z-[99]')}
            show={open}
            enter="transform transition ease-in-out duration-300"
            enterFrom="translate-x-full"
            enterTo="translate-x-90"
            leave="transform transition ease-in-out duration-300"
            leaveFrom="translate-x-90"
            leaveTo="translate-x-full"
          >
            <NotificationList />
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default Notification;
